import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FullPageLoader from '@src/common/FullPageLoader';
import { useLanguage } from "@src/context/LanguageContext";



const RuleEngine = () => {
    const {translations} = useLanguage();

    // let authUserInfo = secureStorage.getItem('authUserInfo');
    // let userId = authUserInfo && authUserInfo.user_data && authUserInfo.user_data.id
    // eslint-disable-next-line
    let [loading, setLoading] = useState<boolean>(false)

    const navigate = useNavigate();

    // const modalSwitch = (param: string, cases: { [key: string]: any }) => {
    //     if (cases[param]) {
    //         return cases[param]
    //     } else {
    //         return cases.default
    //     }
    // }

    // const [updateFormType, setUpdateFormType] = useState("");
    // const [showFormName, setShowFormName] = useState("");
    // const [updateModal, setUpdateModal] = useState(false);


    // const showUpdateModal = (updateFormType: string, action: boolean, formName: string) => {
    //     setUpdateModal(action);
    //     setUpdateFormType(updateFormType);
    //     setShowFormName(formName)
    // }

    // const handlerLoader = (loader: boolean) => {
    //     setLoading(loader)
    // }

    // const handleModalCloseFromChild = () => {
    //     showUpdateModal("", false, '')
    // }
   

    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            <div className="container-fluid main-outer">
                <div className="top-heading">
                    <h1>{translations.Navigation?.['Rule Engine'] || translations.commonMsg?.loading}</h1>
                </div>
                <div className="rule-engine-menu-sec">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="menu-list">
                                <div>
                                    <div className="menu-icn">
                                        <i className="ic-configuration"></i>
                                    </div>
                                    <h2>{translations.RuleEngine?.['Configuration'] || translations.commonMsg?.loading}</h2>
                                </div>
                                <ul>
                                    <li>
                                        <a href='#/' onClick={(() => navigate('/role-list'))}>{translations.RuleEngine?.['User/Role Management'] || translations.commonMsg?.loading}</a>
                                    </li>   
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )

}

export default RuleEngine;